
import React from 'react';
import { Instagram, TrendingUp, Clock, TwitchIcon, Zap, Youtube, Twitter, MessageSquare } from 'lucide-react';

export const getPlatformIcon = (platform: string) => {
  switch (platform) {
    case 'instagram':
      return <Instagram className="h-4 w-4" />;
    case 'tiktok':
      return <TwitchIcon className="h-4 w-4" />; // Using Twitch as a stand-in for TikTok
    case 'youtube':
      return <Youtube className="h-4 w-4" />;
    case 'twitter':
      return <Twitter className="h-4 w-4" />;
    default:
      return <MessageSquare className="h-4 w-4" />;
  }
};

export const getTrendIcon = (trend: string) => {
  switch (trend) {
    case 'viral':
      return <Zap className="h-4 w-4 text-yellow-400" />;
    case 'rising':
      return <TrendingUp className="h-4 w-4 text-green-500" />;
    case 'steady':
      return <Clock className="h-4 w-4 text-blue-400" />;
    default:
      return <TrendingUp className="h-4 w-4" />;
  }
};
